//Modules
import React, { useState } from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
//Styles
import styled from "styled-components"
import { font, spacing, grays, flex, boxShadow } from "../../Utilities"
//Icons
import { TiPlus, TiMinus } from "react-icons/ti"

const AccordionSection = ({ qualification }) => {
  const [questionOpen, setQuestionOpen] = useState(false)

  const {
    name,
    body: { json },
  } = qualification

  const options = {
    renderNode: {
      "embedded-asset-block": node => {
        const url = node.data.target.fields.file["en-US"].url
        const alt = node.data.target.fields.description["en-US"]

        return (
          <StyledEmbed>
            <img src={url} alt={alt} />
          </StyledEmbed>
        )
      },
    },
  }

  return (
    <StyledAccordionSection>
      <div
        className={"faq " + (questionOpen ? "open" : "")}
        onClick={() => setQuestionOpen(!questionOpen)}
        onKeyPress={e => {
          if (e.which === 13) {
            setQuestionOpen(!questionOpen)
          }
        }}
        role="button"
        tabIndex="0"
      >
        <div className="faq-question">
          {name} {questionOpen ? <TiMinus /> : <TiPlus />}
        </div>
        <div className="faq-answer">
          {documentToReactComponents(json, options)}
        </div>
      </div>
    </StyledAccordionSection>
  )
}

const StyledAccordionSection = styled.article`
  .faq {
    .faq-question {
      ${flex("row", "space-between", "center")};
      ${font("S")};
      transition: all 0.4s ease-in;
      background: ${grays[2]};
      padding: ${spacing.S};
    }

    .faq-answer {
      padding: 0 ${spacing.M};
      opacity: 0;
      max-height: 0;
      overflow-y: hidden;
      transition: all 0.4s ease-in;
      box-shadow: ${boxShadow.light};

      h2 {
        ${font("M")};
        margin-bottom: ${spacing.XS};
      }

      h3 {
        ${font("SSM")};
        margin-bottom: ${spacing.XS};
      }

      ul {
        ${font("S")};
        margin-bottom: ${spacing.M};
        li {
          margin-bottom: ${spacing.XS};
          margin-left: ${spacing.L};
        }
      }
    }
  }
  .open {
    .faq-answer {
      max-height: 3000px;
      opacity: 1;
      padding: ${spacing.M};
    }
  }
`

const StyledEmbed = styled.div`
  width: 85%;
  margin: 0 auto;
  margin-bottom: ${spacing.M};
  border: 2px solid ${grays[6]};

  img {
    width: 100%;
  }
`

export default AccordionSection
